// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"b35fb766","417":"d57ebc78","605":"8feb35c6","624":"a15d7624","648":"1dcad472","855":"d48b0ca7","968":"167f5055"}[chunkId] + ".chunk.js";
};